<template>
  <el-dialog
    title="编辑公司管理列表"
    :visible="managersDialogType == 'company'"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    @open="getManagerCompanyList"
    width="50%"
  >
    <div>
      <el-form label-position="right" label-width="150px">
        <el-form-item label="公司管理">
          <p v-for="item in companyList" :key="item.id">
            <el-checkbox v-model="item.isSelect">{{ item.name }}</el-checkbox>
          </p>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="saveCompany" :loading="isLoading"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  managerManagerCompanyList,
  managerAllCompanyList,
  managerUpdateManagerCompany,
} from '@/api/manager'
export default {
  data() {
    return {
      isLoading: false,
      managerDetails: {},
      companyList: [],
    }
  },
  props: {
    managersDialogType: {},
    managerId: {
      default: 0,
    },
    managerInfo: {},
  },
  methods: {
    // 关闭模态框
    closeDialog() {
      this.managerDetails = {}
      this.$emit('update:managersDialogType', '')
    },
    // 获取该用户公司管理
    async getManagerCompanyList() {
      this.companyList = []
      let { code, result } = await managerManagerCompanyList({
        manager_id: this.managerId,
      })
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.getAllCompanyList(result || [])
      }
    },
    // 获取所有公司列表
    async getAllCompanyList(_list) {
      let { code, result } = await managerAllCompanyList()
      if (code == this.CONFIG.CODE_SUCCESS) {
        result.map((item) => {
          item.isSelect = _list.indexOf(item.id) < 0 ? false : true
          return item
        })
        this.companyList = result
      }
    },
    async saveCompany() {
      let _list = []
      for (let i in this.companyList) {
        if (this.companyList[i].isSelect) {
          _list.push(this.companyList[i].id)
        }
      }
      let postData = {
        manager_id: this.managerId,
        company_list: _list,
      }
      this.isLoading = true
      let { code, msg } = await managerUpdateManagerCompany(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.closeDialog()
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
